// @ts-ignore
import Slider from './Slider';
// @ts-ignore
import MainNavigation from './MainNavigation';
// @ts-ignore
import ProductList from './ProductList';
// @ts-ignore
import Login from './Login';
// @ts-ignore
import Utilities from './Utilities';
// @ts-ignore
import CustomCategoryNavigation from './CustomCategoryNavigation';
// @ts-ignore
import CustomFilter from './CustomFilter';
// @ts-ignore
import ProductDetails from './ProductDetails';

export default function () {
    Slider();
    MainNavigation();
    ProductList();
    Login();
    Utilities();
    CustomCategoryNavigation();
    CustomFilter();
    ProductDetails();
}
